import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMedal"><Path fillRule="evenodd" clipRule="evenodd" d="M12 1C7.58172 1 4 4.58172 4 9C4 11.5264 5.17108 13.7793 7 15.2454V23.6176L12 21.1176L17 23.6176V15.2454C18.8289 13.7793 20 11.5264 20 9C20 4.58172 16.4183 1 12 1ZM9 16.4185C9.92643 16.7935 10.9391 17 12 17C13.0609 17 14.0736 16.7935 15 16.4185V20.3815L12 18.8815L9 20.3815V16.4185Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMedal;
